import { data } from "jquery";
import store from "../store.js";
const globalState = store.getState().globaReducer;

export const changeTextAction = (text) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch({ type: "CHANGE", text });
    }, 2000);
  };
};

export const fetchTest = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["getStundentTest"];

    dispatch({ type: "FETCHING_TEST" });

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (test) => {
        dispatch({ type: "SET_TEST", test: test });
      },
      (err) => {
        console.log(err);
      }
    );
  };
};

export const getSurveyQuestion = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["getSurvey"];

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (data) => {
        dispatch({ type: "SET_SURVEY_QUE", data });
      },
      (err) => {
        console.log(err);
      }
    );
  };
};

export const getFeedbackQuestion = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["feedbackQue"];

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (data, isAnswer) => {
        if (isAnswer) {
          dispatch({ type: "SET_FEEDBACK_QUE", data, isAnswer: true });
        } else {
          dispatch({ type: "SET_FEEDBACK_QUE", data, isAnswer: false });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };
};

export const submitSurvey = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["submitSurvey"];

    dispatch({ type: "SHOW_SPPINER" });

    callApi(
      url,
      task,
      globalState.token,
      { data },
      () => {
        store.dispatch(
          getSurveyQuestion({
            survey_id: data.survey_id,
            player_id: data.player_id,
            player_name: "",
          })
        );

        setTimeout(() => {
          dispatch({ type: "HIDE_SPPINER" });
        }, 1000);
      },
      (err) => {
        console.log(err);
      }
    );
  };
};

export const submitFeedback = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["submitFeedbck"];

    dispatch({ type: "SHOW_SPPINER" });

    callApi(
      url,
      task,
      globalState.token,
      { data },
      () => {
        store.dispatch(
          getFeedbackQuestion({
            player_id: data.player_id,
          })
        );

        setTimeout(() => {
          dispatch({ type: "HIDE_SPPINER" });
        }, 1000);
      },
      (err) => {
        console.log(err);
      }
    );
  };
};

export const fetchTestSummery = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["userTestData"];
    const task = globalState["apiTask"]["gettestSummary"];

    dispatch({ type: "FETCHING_TEST_SUMMERY" });
    callApi(
      url,
      task,
      globalState.token,
      { data },
      (test) => {
        dispatch({ type: "SET_TEST_SUMMERY", test: test });
      },
      (err) => {
        if (err.status === "404") {
          dispatch({ type: "SET_TEST_RESPONSE_ERROR", data: err });
        }
        console.log(err);
      }
    );
  };
};

export const approveStatus = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["userTestData"];
    const task = globalState["apiTask"]["reviewTest"];

    callApi(
      url,
      task,
      globalState.token,
      { data },
      // () => {
      (apiData) => {
        // window.history.go(-1);
        // to handel back on success with new params handling (via localstorage)
        // goBackCallback();
        // dispatch({ type: "SET_MSG", msg: { ...apiData, msgFrom } });
        window.location.reload();
      },
      (err) => {
        // dispatch({ type: "HIDE_SPPINER" });
        alert(err.msg ? err.msg : "Somthing went wrong");
      },
      true
    );
  };
};

export const getFeedbackSummery = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["feedbackSummery"];

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (data) => {
        dispatch({ type: "SET_FEEDBACK_SUMMERY", data });
      },
      (err) => {
        console.log(err);
      }
    );
  };
};

export const fetchRadarData = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["getgcoordchartdata"];

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (score) => {
        dispatch({ type: "SET_RADAR_CHART", score: score });
      },
      (err) => {
        console.log("radar chart error", err);
      }
    );
  };
};
export const assignTest = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["assignTest"];

    dispatch({ type: "SHOW_SPPINER" });

    console.log("datadata", data);

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (test) => {
        dispatch({ type: "HIDE_SPPINER" });
      },
      () => {
        dispatch({ type: "HIDE_SPPINER" });
      }
    );
  };
};

export const fetchAllStudent = () => {
  return (dispatch) => {
    const myUD = JSON.parse(localStorage.getItem("ud"));
    const schoolId = !!myUD ? myUD.sc : undefined;
    console.log("globalState", globalState);
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["getStudentList"];
    callApi(
      url,
      task,
      globalState.token,
      { data: { sch_code: schoolId, grade_id: "" } },
      (student) => {
        dispatch({ type: "SET_ALL_STUDENT", student: student });
        dispatch({ type: "SET_NEW_STUDENT" });
      },
      (err) => {}
    );
  };
};

export const fetchHomeCardData = () => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["refreshdata"];
    const myUd = JSON.parse(localStorage.getItem("ud"));

    callApi(
      url,
      task,
      globalState.token,
      { data: { sch_code: myUd.sc } },
      (count) => {
        dispatch({ type: "HOME_PAGE_BUBBLES", count: count });
      },
      (err) => {}
    );
  };
};

export const setHomeCardData = (data) => {
  return (dispatch) => {
    dispatch({ type: "SET_HOME_BUBBLE", data: data });
  };
};

export const filterStudent = (query) => {
  return (dispatch) => {
    dispatch({ type: "FILTER_STUDENT", query });
  };
};

export const columnFilter = (query) => {
  return (dispatch) => {
    dispatch({ type: "COLUMN_FILTER", query });
  };
};

export const resetFilter = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_FILTER" });
  };
};

export const publishColumnFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: "PUBLISH_COLUMN_FILTER", query: filter });
  };
};

export const fetchNewStudent = (index) => {
  return (dispatch) => {
    dispatch({ type: "SET_NEW_STUDENT", index: index });
  };
};

export const showSpinner = () => {
  return {
    type: "SHOW_SPPINER",
  };
};

export const hideSpinner = () => {
  return {
    type: "HIDE_SPPINER",
  };
};

export const clearSurvey = () => {
  return (dispatch) => {
    dispatch({ type: "SET_SURVEY_QUE", data: {} });
  };
};

export const clearFeedback = () => {
  return (dispatch) => {
    dispatch({ type: "SET_FEEDBACK_QUE", data: {}, isAnswer: false });
  };
};

export const getSurvey = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["surveyList"];

    dispatch({ type: "FETCHING_SURVEY" });

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (survey) => {
        dispatch({ type: "SET_SURVEY", survey });
      },
      (err) => {
        console.log(err);
      }
    );
  };
};

export const resetState = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_TEST_RESPONSE" });
  };
};

export const findTestById = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["userTestData"];
    const task = globalState["apiTask"]["testResponse"];

    dispatch({ type: "FETCHING_TEST_RESPONSE" });

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (test) => {
        dispatch({ type: "SET_TEST_RESPONSE", test });
      },
      (err) => {
        dispatch({ type: "FETCHING_TEST_RESPONSE_ERROR", err });
      }
    );
  };
};

export const findReportedById = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["reportedQuesList"];
    dispatch({ type: "FETCHING_TEST_RESPONSE" });

    callApi(
      url,
      task,
      globalState.token,
      { data },
      (test) => {
        dispatch({ type: "SET_TEST_RESPONSE", test });
      },
      (err) => {
        dispatch({ type: "FETCHING_TEST_RESPONSE_ERROR", err });
      }
    );
  };
};

export const hideEditModal = () => {
  return (dispatch) => {
    dispatch({ type: "HIDE_EDIT_MODAL" });
  };
};

export const showEditModal = (data) => {
  return (dispatch) => {
    dispatch({ type: "SHOW_EDIT_MODAL", ...data });
  };
};

export const showReportedEditModal = (data) => {
  return (dispatch) => {
    dispatch({ cases: "SHOW_REPORTED_EDIT_MODAL", ...data });
  };
};

export const hideReportedEditModal = () => {
  return (dispatch) => {
    dispatch({
      cases: "HIDE_REPORTED_EDIT_MODAL",
      type: "HIDE_REPORTED_EDIT_MODAL",
    });
  };
};

export const updateReportedQuestion = (data, msgFrom) => {
  console.log("datadata", data);
  return (dispatch) => {
    dispatch({ type: "SHOW_SPPINER" });

    const url = globalState["host"] + globalState["apiEnd"]["userTestData"];
    const task = globalState["apiTask"]["reportIssue"];
    callApi(
      url,
      task,
      globalState.token,
      { data },
      // () => {
      //   dispatch(
      //     findTestById({
      //       player_id: data.player_id,
      //       test_id: data.test_id,
      //       grade_id: data.grade_id,
      //     })
      //   );
      //   setTimeout(() => {
      //     dispatch({ type: "HIDE_EDIT_MODAL" });
      //     dispatch({ type: "HIDE_SPPINER" });
      //   }, 1000);
      // },
      (apiData) => {
        dispatch(
          findReportedById({
            player_id: JSON.parse(localStorage.getItem("params")).uid,
            test_id: JSON.parse(localStorage.getItem("params")).tid,
            assessor_id: data.assessor_id,
            sch_code: JSON.parse(localStorage.getItem("ud")).master[0].sch_code,
          })
        );
        setTimeout(() => {
          dispatch({
            cases: "HIDE_REPORTED_EDIT_MODAL",
            type: "HIDE_REPORTED_EDIT_MODAL",
          });
          dispatch({ type: "HIDE_SPPINER" });
          console.log("msgmsg", apiData, msgFrom);
          dispatch({ type: "SET_MSG", msg: { ...apiData, msgFrom } });
        }, 1000);
      },
      (err) => {
        dispatch({ type: "HIDE_SPPINER" });
        alert(err.msg ? err.msg : "Somthing went wrong");
      }
    );
  };
};

// changes done to show modal when reportissue api is hit and
//extra true argument is passed as no status check is required for it
export const reportIssue = (data, msgFrom) => {
  console.log("datadata", data);
  return (dispatch) => {
    dispatch({ type: "SHOW_SPPINER" });

    const url = globalState["host"] + globalState["apiEnd"]["userTestData"];
    const task = globalState["apiTask"]["reportIssue"];

    callApi(
      url,
      task,
      globalState.token,
      { data },
      // () => {
      //   dispatch(
      //     findTestById({
      //       player_id: data.player_id,
      //       test_id: data.test_id,
      //       grade_id: data.grade_id,
      //     })
      //   );
      //   setTimeout(() => {
      //     dispatch({ type: "HIDE_EDIT_MODAL" });
      //     dispatch({ type: "HIDE_SPPINER" });
      //   }, 1000);
      // },
      (apiData) => {
        dispatch(
          findTestById({
            player_id: data.player_id,
            test_id: data.test_id,
            grade_id: data.grade_id,
          })
        );
        setTimeout(() => {
          dispatch({ type: "HIDE_EDIT_MODAL" });
          dispatch({ type: "HIDE_SPPINER" });
          console.log("msgmsg", apiData);
          dispatch({ type: "SET_MSG", msg: { ...apiData, msgFrom } });
        }, 1000);
      },
      (err) => {
        dispatch({ type: "HIDE_SPPINER" });
        alert(err.msg ? err.msg : "Somthing went wrong");
      },
      true
    );
  };
};

// for alert modal after issue is reported

export const hideMessageModal = () => ({
  type: "RESET_MSG",
});

// export const reviewTest = (data) => {
// export const reviewTest = (data, goBackCallback) => {
export const reviewTest = (data, msgFrom) => {
  return (dispatch) => {
    dispatch({ type: "SHOW_SPPINER" });

    const url = globalState["host"] + globalState["apiEnd"]["userTestData"];
    const task = globalState["apiTask"]["reviewTest"];

    callApi(
      url,
      task,
      globalState.token,
      { data },
      // () => {
      (apiData) => {
        dispatch({ type: "HIDE_SPPINER" });
        // window.history.go(-1);
        // to handel back on success with new params handling (via localstorage)
        // goBackCallback();
        console.log("msgmsg", apiData);
        dispatch({ type: "SET_MSG", msg: { ...apiData, msgFrom } });
      },
      (err) => {
        dispatch({ type: "HIDE_SPPINER" });
        alert(err.msg ? err.msg : "Somthing went wrong");
      },
      true
    );
  };
};

// export const reTest = (data) => {
// export const reTest = (data, goBackCallback) => {
export const reTest = (data, msgFrom) => {
  return (dispatch) => {
    dispatch({ type: "SHOW_SPPINER" });

    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["reTest"];

    callApi(
      url,
      task,
      globalState.token,
      { data },
      // () => {
      (apiData) => {
        dispatch({ type: "HIDE_SPPINER" });
        // window.history.go(-1);
        // to handel back on success with new params handling (via localstorage)
        // goBackCallback();
        console.log("msgmsg", apiData);
        dispatch({ type: "SET_MSG", msg: { ...apiData, msgFrom } });
      },
      (err) => {
        dispatch({ type: "HIDE_SPPINER" });
        alert(err.msg ? err.msg : "Somthing went wrong");
      },
      true
    );
  };
};

export const findUserById = (id) => {
  return (dispatch) => {
    const students = JSON.parse(localStorage.getItem("std"));
    const schoolId = JSON.parse(localStorage.getItem("ud")).sc;

    console.log("this.props.match students", students);
    console.log("this.props.match schoolId", schoolId);

    if (students && students.length) {
      const student = students.find((std) => {
        console.log("this.props.match std.id == id", std.id == id);
        console.log("this.props.match std.id", std.id);
        console.log("this.props.match id", id);
        return std.id == id;
      });
      console.log("this.props.match schoolId", student);
      // console.log();
      dispatch({ type: "SET_STUDENT_BY_ID", std: student });
    } else {
      const url = globalState["host"] + globalState["apiEnd"]["metaData"];
      const task = globalState["apiTask"]["getStudentList"];

      callApi(
        url,
        task,
        globalState.token,
        { data: { sch_code: schoolId } },
        (student) => {
          dispatch({ type: "SET_ALL_STUDENT", student: student });
          dispatch({ type: "SET_NEW_STUDENT" });
        }
      );
    }
  };
};

export const fetchStudentGradeWiseList = (gradeId) => {
  return (dispatch) => {
    const schoolId = JSON.parse(localStorage.getItem("ud")).sc;
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["getStudentList"];
    callApi(
      url,
      task,
      globalState.token,
      { data: { sch_code: schoolId, grade_id: gradeId } },
      (student) => {
        // console.log("fetchStudentGradeWiseList", student);
        dispatch({ type: "SET_PROFILE_PAGE_STUDENT", student: student });
      },
      (err) => {
        console.log(err);
      }
    );
  };
};

export const resetProfilePageReducer = () => {
  return {
    type: "RESET_PROFILE_PAGE_STUDENT",
  };
};

export const setParams = (params) => {
  return {
    type: "SET_PARAMS",
    payload: params,
  };
};

// for filterby State
export const setSortByState = ({ pageName, filterBy, orderBy, sortBy }) => {
  return {
    type: "SET_FILTER_STATE",
    pageName,
    filterBy,
    orderBy,
    sortBy,
  };
};
export const logoutShow = (playerId, updatingState) => {
  console.log("Player Id Passed in action.js", playerId);
  const url = globalState["host"] + globalState["apiEnd"]["metaData"];
  const task = globalState["apiTask"]["logOut"];
  callApi(
    url,
    task,
    globalState.token,
    { data: { player_id: playerId } },
    updatingState
  );
};

// const logoutCallback = (data) => {
//   // alert("hello");
//   console.log("my data", data);
// };

export const fetchAllPlayers = () => {
  return (dispatch) => {
    const myUD = JSON.parse(localStorage.getItem("ud"));
    const schoolId = !!myUD ? myUD.sc : undefined;
    console.log("globalState", globalState);
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["getStudentList"];
    callApi(
      url,
      task,
      globalState.token,
      { data: { sch_code: schoolId, grade_id: "" } },
      (student) => {
        dispatch({ type: "SET_ALL_PUBLISH_STUDENT", student: student });
        // dispatch({ type: "SET_NEW_STUDENT" });
      },
      (err) => {}
    );
  };
};

export const publishStudent = (data) => {
  return (dispatch) => {
    const schoolId = JSON.parse(localStorage.getItem("ud")).sc;
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["setpublishstatus"];
    callApi(
      url,
      task,
      globalState.token,
      data,
      (response) => {
        // console.log("fetchStudentGradeWiseList", student);
        dispatch({ type: "SET_PUBLISH_TOGGLE", data: response });
      },
      (err) => {
        dispatch({ type: "RESET_PUBLISH_TOGGLE" });
        alert(err.msg ? err.msg : "Somthing went wrong");
        console.log(err);
      }
    );
  };
};

export const fetchAllOfflineSyncTest = () => {
  return (dispatch) => {
    const myUD = JSON.parse(localStorage.getItem("ud"));
    const schoolId = !!myUD ? myUD.sc : undefined;
    console.log("globalState", globalState);
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["testlistinfo"];
    callApi(
      url,
      task,
      globalState.token,
      { data: { action_tag: "read" } },
      (student) => {
        dispatch({ type: "SET_ALL_PUBLISH_STUDENT", payload: student });
        // dispatch({ type: "SET_NEW_STUDENT" });
      },
      (err) => {}
    );
  };
};

export const syncOfflineAudio = (data) => {
  return (dispatch) => {
    const myUD = JSON.parse(localStorage.getItem("ud"));
    const schoolId = !!myUD ? myUD.sc : undefined;
    console.log("globalState", globalState);
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["offlineprocessaudio"];
    callApi(
      url,
      task,
      globalState.token,
      data,
      (student) => {
        dispatch({ type: "DATA_SYNCED_OFFLINE", payload: student });
        // dispatch({ type: "SET_NEW_STUDENT" });
      },
      (err) => {
        alert(err.msg ? err.msg : "Somthing went wrong");
        console.log(err);
      }
    );
  };
};

export const fetchAllFlagNotes = (data) => {
  return (dispatch) => {
    const myUD = JSON.parse(localStorage.getItem("ud"));
    const schoolId = !!myUD ? myUD.sc : undefined;
    console.log("globalState", globalState);
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["getstudentflagnotes"];
    callApi(
      url,
      task,
      globalState.token,
      data,
      (response) => {
        dispatch({ type: "SET_ALL_FLAG_NOTES", data: response });
      },
      (err) => {
        // alert(err.msg ? err.msg : "Somthing went wrong");
        console.log(err);
      }
    );
  };
};

export const submitCommentFlagNotes = (data) => {
  return (dispatch) => {
    const myUD = JSON.parse(localStorage.getItem("ud"));
    const schoolId = !!myUD ? myUD.sc : undefined;
    console.log("globalState", globalState);
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["setstudentflagnotes"];
    callApi(
      url,
      task,
      globalState.token,
      data,
      (response) => {
        window.location.reload();
      },
      (err) => {
        alert(err.msg ? err.msg : "Somthing went wrong");
        console.log(err);
      }
    );
  };
};

export const flagQuestion = (data) => {
  return (dispatch) => {
    console.log("globalState", globalState);
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["flagqueitem"];
    callApi(
      url,
      task,
      globalState.token,
      data,
      (response) => {
        // window.location.reload();
      },
      (err) => {
        alert(err.msg ? err.msg : "Somthing went wrong");
        console.log(err);
      }
    );
  };
};

export const superAdmin = (data) => {
  return (dispatch) => {
    console.log("globalState", globalState);
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["flagqueitems"];
    dispatch({ type: "SHOW_SPPINER" });
    callApi(
      url,
      task,
      globalState.token,
      data,
      (response) => {
        dispatch({ type: "HIDE_SPPINER" });
      },
      (err) => {
        dispatch({ type: "HIDE_SPPINER" });
        // alert(err.msg ? err.msg : "Somthing went wrong");
        console.log(err);
      }
    );
  };
};

function callApi(url, task, token, data, callback, errorCallback, noCheckMsg) {
  fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    headers: {
      task: task,
      "Content-Type": "application/json",
      Accept: "application/json",
      token: token,
    },
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log("datadata inside then", data);
      if (task === globalState["apiTask"]["logOut"] && data.status === "201") {
        data.data = "Successfully Logged Out";
      } else if (
        task === globalState["apiTask"]["logOut"] &&
        data.status !== "201"
      ) {
        data.data = "Unable to Logout";
      }
      // for case of report issue msg
      if (noCheckMsg) {
        callback(data);
      } else {
        if (data.status === "201") {
          callback(data["data"]);
        } else if (data.status === "406") {
          callback(data["data"], true);
        } else {
          callback([]);
          errorCallback(data);
        }
      }
    })
    .catch((err) => {
      console.log(err);
      // callback([]);
      // errorCallback(err);
    });
}
